module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "searchDiv"
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "text-align": "left",
      "padding-top": "20px"
    },
    attrs: {
      "model": _vm.form,
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "题目编号",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.form.problemGuid),
      callback: function($$v) {
        _vm.form.problemGuid = $$v
      },
      expression: "form.problemGuid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主题号",
      "label-width": "60px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.form.problemMain),
      callback: function($$v) {
        _vm.form.problemMain = $$v
      },
      expression: "form.problemMain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关键词",
      "label-width": "60px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.form.keywords),
      callback: function($$v) {
        _vm.form.keywords = $$v
      },
      expression: "form.keywords"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "60px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.form.title = $$v
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其他",
      "label-width": "40px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.form.qt),
      callback: function($$v) {
        _vm.form.qt = $$v
      },
      expression: "form.qt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.searchAll
    }
  }, [_vm._v("全部")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7298b586"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/problemSearch.vue
// module id = 649
// module chunks = 2